<template>
  <EmailSettings />
</template>

<script>

import EmailSettings from "@/components/Account/EmailSettings.vue";

export default {
  name: 'CalendarConfig',
  components: {
    EmailSettings
  },
  data() {
    return {

    };
  },
  methods: {

  },
};
</script>
